import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import Layout from "./Layout";
import { COLLECTION, SESSION } from "../../../data/constant";
import { collection, query, where, getDocs } from "firebase/firestore";

const UserProfile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [dataChanged, setDataChanged] = useState(false);
  const [snackPreferences, setSnackPreferences] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const sessionId = localStorage.getItem(SESSION.USER_SESSION_ID);
        if (!sessionId) {
          throw new Error("User session ID not found.");
        }

        const userSessionDocRef = doc(db, COLLECTION.USER_SESSION, sessionId);
        const userSessionDocSnap = await getDoc(userSessionDocRef);

        if (!userSessionDocSnap.exists()) {
          throw new Error("User session document not found");
        }

        const sessionData = userSessionDocSnap.data();
        setUserId(sessionData.userID);

        const userDetailsDocRef = doc(db, COLLECTION.USER, sessionData.userID);
        const userDetailsDocSnap = await getDoc(userDetailsDocRef);

        if (!userDetailsDocSnap.exists()) {
          throw new Error("User details document not found");
        }

        setUserData(userDetailsDocSnap.data());

        const snackPrefQuery = query(
          collection(db, COLLECTION.SNACKPREFERENCES),
          where("phoneNumber", "==", sessionData.phoneNumber)
        );

        const snackPrefSnap = await getDocs(snackPrefQuery);

        if (!snackPrefSnap.empty) {
          const docData = snackPrefSnap.docs[0].data();
          const snackList = docData.snacks
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);
          setSnackPreferences(snackList);
        } else {
          setSnackPreferences([]);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, [dataChanged]);

  if (loading) return <div>Loading...</div>;
  if (!userData) return <div>User data not found</div>;

  return (
    <Layout
      userData={userData}
      userId={userId}
      loading={loading}
      snackPreferences={snackPreferences}
      userPhoneNumber={userData.phoneNumber}
    />
  );
};

export default UserProfile;